import React from "react";
import { useLanguage } from "../../App";
import { Coins } from "lucide-react";

const CharacterInfo = ({ character }) => {
  const { language } = useLanguage();
  const isEnglish = language === "en";
  if (!character) return null;
  const rarityColor = {
    dasar: "bg-gray-200 text-gray-700",
    shalih: "bg-emerald-200 text-emerald-700",
    teladan: "bg-indigo-200 text-indigo-700",
    muttaqin: "bg-amber-200 text-amber-700",
    common: "bg-gray-200 text-gray-700",
    rare: "bg-emerald-200 text-emerald-700",
    epic: "bg-indigo-200 text-indigo-700",
    legendary: "bg-amber-200 text-amber-700",
  }[character.rarity || "dasar"];
  const rarityLabel = {
    dasar: isEnglish ? "Basic" : "Dasar",
    shalih: isEnglish ? "Righteous" : "Shalih",
    teladan: isEnglish ? "Exemplary" : "Teladan",
    muttaqin: isEnglish ? "God-conscious" : "Muttaqin",
    common: isEnglish ? "Basic" : "Dasar",
    rare: isEnglish ? "Righteous" : "Shalih",
    epic: isEnglish ? "Exemplary" : "Teladan",
    legendary: isEnglish ? "God-conscious" : "Muttaqin",
  }[character.rarity || "dasar"];
  const statLabel = (key) => {
    const map = {
      wisdom: isEnglish ? "Wisdom" : "Hikmah",
      courage: isEnglish ? "Courage" : "Keberanian",
      empathy: isEnglish ? "Empathy" : "Empati",
    };
    return map[key] || key;
  };
  return (
    <div className="px-4 py-3 space-y-2">
      <div className="flex items-center justify-between">
        <h3 className="text-lg font-bold">{isEnglish ? character.name_en || character.name : character.name}</h3>
        <span className={`px-2 py-1 rounded-full text-xs font-semibold ${rarityColor}`}>
          {rarityLabel}
        </span>
      </div>
      <p className="text-sm text-muted-foreground">
        {isEnglish ? character.description_en || "" : character.description || ""}
      </p>
      {!!character.price && (
        <div className="flex items-center gap-1 text-sm font-semibold text-amber-600">
          <Coins className="w-4 h-4" /> {character.price.toLocaleString()}
        </div>
      )}
      {character.stats && (
        <div className="grid grid-cols-3 gap-2 pt-1">
          {Object.entries(character.stats).map(([key, val]) => (
            <div key={key} className="space-y-1">
              <span className="text-[11px] font-medium text-muted-foreground">
                {statLabel(key)}
              </span>
              <div className="h-2 w-full bg-muted rounded-full overflow-hidden">
                <div className="h-full bg-primary rounded-full" style={{ width: `${Math.min(100, Math.max(0, val))}%` }} />
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default CharacterInfo;
